<div class="menu">

    <!-- big, opaque, overlapping shapes in the manner of the 'werken bij' banner -->
    <svg class="vorm v-golf" viewBox="0 0 300 190" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0,0 H300 V112 Q286,150 262,118 Q250,100 240,124 L236,172 Q232,186 227,172
                 L223,120 Q204,92 184,128 Q164,162 140,122 Q128,104 116,122 L112,156 Q108,168 103,156
                 L99,120 Q80,90 57,126 Q34,162 12,122 Q6,112 0,118 Z" />
    </svg>
    <div class="vorm v-oranje"></div>
    <div class="vorm v-perzik"></div>
    <div class="vorm v-geel"></div>
    <div class="vorm v-roze"></div>

    <div class="menu-brand">
        <div class="logo-card">
            <img src="assets/img/logo.svg" class="menu-logo" alt="op Stoom" />
        </div>
    </div>

    <ul>
        <li [class.active]="isActive('/tickets')">
            <a (click)="goToTicket()">
                <span class="label">{{ "menu.ticket" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/branches')">
            <a (click)="goToBranche()">
                <span class="label">{{ "menu.branches" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/departments')">
            <a (click)="goToDepartments()">
                <span class="label">{{ "menu.departments" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/users')">
            <a (click)="goToUsers()">
                <span class="label">{{ "menu.users" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/priority')">
            <a (click)="goToPriority()">
                <span class="label">{{ "menu.priority" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/status')">
            <a (click)="goToStatus()">
                <span class="label">{{ "menu.status" | translate }}</span>
            </a>
        </li>
        <li [class.active]="isActive('/instellingen')">
            <a (click)="goToSettings()">
                <span class="label">{{ "menu.settings" | translate }}</span>
            </a>
        </li>
    </ul>
</div>
